import { CreditLineRequestFundingType } from './credit-line-request/credit-line-request.funding-type.enum';
import { z } from 'zod';

export class CreditLineBreakdown {
    [CreditLineRequestFundingType.Buyer]?: number;
    [CreditLineRequestFundingType.Supplier]?: number;
}

export const CreditLineBreakdownSchema = z
    .object({
        buyer: z.number().optional(),
        supplier: z.number().optional(),
    })
    .strict();
